export class Requesters {
		public idMongo: string
		public name: string
		public cpf: string
		public email: string
		public telephone: string
		public ip: string
		public address: string
		public status: string
}

export class DemandsRequester {
		public idMongo: string
		public address: string
		public status: string
		public identification: number
		public date: string
		public locationReference: string
		public serviceType: string
		public considerations: string
		public problems: Array<string>
		public images: Array<string>
		public questions: Array<{
				question: string,
				option: string
		}>
		public open: boolean
}

export class ReturnDemandsRequeste {
		public content: Array<DemandsRequester>
		public numberOfDemands: number
}
